import Vue from "vue";

const navig = [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Moje kursy',
    route: 'my-courses',
    icon: 'BookOpenIcon',
  },
  {
    title: 'Sklep',
    route: 'shop',
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'Zamówienia',
    route: 'orders',
    icon: 'ShoppingBagIcon',
  },
  {
    title: 'Ustawienia',
    route: 'settings',
    icon: 'SettingsIcon',
  },
]

if (Vue.prototype.$workbox === null) {
  navig.splice(4, 1)
  navig.splice(4, 1)
}

export default navig
